import React from 'react';
import TableComponent from "../Common/TableComponent";
import "../../Styles/Components/ServerDetailsBasicTab.css";

const ServerDetailsBasicTab = ({
    serverDetails,
    getGraphanaLink,
    getMarketType,
    getSiteCode,
    getLobbies,
    activeLast7Days
}) => {
    const renderServerID = () => (
        <span>
            {serverDetails.ServerID} (
            <a
                href={getGraphanaLink()}
                target="_blank"
                rel="noreferrer"
                className="text-blue-600 hover:text-blue-800"
            >
                Charts
            </a>
            )
        </span>
    );

    const renderInstallSD = () => {
        const orderNumber = serverDetails.OrderNumber;
        if (orderNumber && orderNumber.startsWith('SD-')) {
            return (
                <a
                    href={`https://gamedistribute.atlassian.net/browse/${orderNumber.toUpperCase()}`}
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-600 hover:text-blue-800"
                >
                    {orderNumber}
                </a>
            );
        }
        return orderNumber; // Fallback if no SD format
    };

    const serverSettingsData = {
        'ServerID': renderServerID(),
        'ServerName': serverDetails.ServerName,
        'OperatorName': `${serverDetails.OperatorName} (${serverDetails.OperatorID})`,
        'OperatorID': serverDetails.OperatorID,
        'Lobby Name': serverDetails.LobbyName,
        'BusinessUnit': serverDetails.MarketCode,
        'MarketType': getMarketType(serverDetails.CasinoSiteID),
        'MarketSiteCode': getSiteCode(serverDetails.CasinoSiteID),
        'SiteName': serverDetails.CasinoSiteID,
        'UsingUGL': getLobbies(),
        'Activity': activeLast7Days,
        'Install SD': renderInstallSD(),
        'Integration': serverDetails.IntegrationType,
    };

    const GamingSystemNameMap = {
        635: "Raptor 1 ARCH (NJS)",
        634: "Quickfire Raptor ARCH (NJP)",
        635: "Quickfire Raptor ARCH (NJS)",
        636: "Raptor 1 ARCH (PAP)",
        644: "Raptor 1 ARCH (MIP)",
        645: "Raptor 1 ARCH (CTP)",
        645: "CTPRGS2ARCLNR",
        647: "Casino Archive 1 Listener (ONP)"
    };

    const apiSettingsData = {
        'APIUrl': serverDetails.APIUrl,
        'APIUsername': serverDetails.APIUserName,
        'APIPassword': serverDetails.APIPassword,
    };

    const goldStandardData = {
        'Max Exposure': serverDetails.MaxExposure,
        'Min Bet': '0',
        'Default Bet': '$2',
        'Max Bet': '0',
    };

    const systemSettingsData = {
        'GamingServerID': serverDetails.GamingServer,
        'GamingSystemName': GamingSystemNameMap[serverDetails.GamingServer] || "Unknown",
    };
    return (
        <div className="server-details-container">
            <div className="card">
                <div className="card-header">Server Settings</div>
                <div className="card-content">
                    <TableComponent data={serverSettingsData} />
                </div>
            </div>

            <div className="card">
                <div className="card-header">API Settings</div>
                <div className="card-content">
                    <TableComponent data={apiSettingsData} />
                </div>
            </div>

            <div className="card">
                <div className="card-header">Gold Standard</div>
                <div className="card-content">
                    <TableComponent data={goldStandardData} />
                </div>
            </div>

            <div className="card">
                <div className="card-header">System Settings</div>
                <div className="card-content">
                    <TableComponent data={systemSettingsData} />
                </div>
            </div>
        </div>

    );
};
export default ServerDetailsBasicTab;